import {RoleBasedPermission} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {usePermission} from '@hproduce/permissions'

/**
 * Only HProduce Production Manager OR HProduce Maintenance Manager can edit colours.
 * Plant is taken from the UpmPlantProvider context (no url params).
 */
export const useCanEditColors = (): boolean => {
  const {plantId, country} = useUpmPlantContext()
  const plantContext = {plantId, countryId: country}

  const isProductionManager = usePermission({
    plantContext,
    permissionTypes: [RoleBasedPermission.HproduceRoleProductionManager]
  })

  const isMaintenanceManager = usePermission({
    plantContext,
    permissionTypes: [RoleBasedPermission.HproduceRoleMaintenanceManager]
  })

  return isProductionManager || isMaintenanceManager
}
